if (!customElements.get("countdown-timer")) {
  customElements.define(
    "countdown-timer",
    class CountdownTimer extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          text: this.querySelector(".countdown-timer__date-time"),
          expirationMessage: this.dataset.expirationMessage,
          targetDate: new Date(this.dataset.targetDate), // Add a data attribute for target date
        };
        setInterval(() => {
          this.updateCountdown();
        }, 1000);
        this.updateCountdown();
      }

      updateCountdown() {
        const currentDate = new Date();
        const timeRemaining = this.elements.targetDate - currentDate;

        if (timeRemaining <= 0) {
          this.elements.text.innerHTML = this.elements.expirationMessage;
        } else {
          const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
          const hours = Math.floor(
            (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          const minutes = Math.floor(
            (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
          );
          const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

          // Ensure single-digit values have a leading zero
          const formattedDays = String(days).padStart(2, "0");
          const formattedHours = String(hours).padStart(2, "0");
          const formattedMinutes = String(minutes).padStart(2, "0");
          const formattedSeconds = String(seconds).padStart(2, "0");

          this.elements.text.innerHTML = `${formattedDays}:${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
        }
      }
    }
  );
}
